<template>
  <div class="container1">
    <slot name="sidebar"></slot>

    <div class="body">
      <slot name="mbody"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss">
@import "@/styles/_variables.scss";
.container1 {
  padding-top: 60px;
  display: flex;
}
</style>